import isEqual from 'lodash-es/isEqual';
import omit from 'lodash-es/omit';

// The fields a policy type switch writes itself
const policyTypeSwitchFields = [
  'selectedOption',
  'noBindHome',
  'noBindAuto',
  'includeUmbrella',
  'includeRenters',
  'isHomeOwner',
  'auto.residenceInsuranceType',
  'global.homeownersPaymentMethod',
  'global.condoPaymentMethod'
];

// True when the agent changed something the offer hasn't been updated with yet. Switching policy
// type re-rates against the saved offer, so those changes would be dropped without a warning.
export const hasUnsavedOfferEdits = ({ dirty, values, initialValues }) =>
  dirty && !isEqual(omit(values, policyTypeSwitchFields), omit(initialValues, policyTypeSwitchFields));
